// Connection type
const pageServidor  = '.';
export const connectionPage = pageServidor;

// Cookies type
// const cookiesServidor        = 'localhost';
const cookiesServidor         = 'dash-movala.chroma-garden.com/';
export const cookiesRegister  = cookiesServidor;

// Cookies name
export const typeCookie       = 'chroma_movala_dash';
export const typeCookiePassw  = 'chroma_movala_passw';
export const typeCookieEmail  = 'chroma_movala_email';
export const typeCookiePage   = 'chroma_movala_page';
export const typeCookiePageId = 'chroma_movala_page_id';
export const typeCookieNewId  = 'chroma_movala_new_id';

// opt box editor
export const config = {
    zIndex: 0,
    readonly: false,
    width: 'auto',
    height: 'auto',
    minHeight: 100,
    direction: '',
    language: 'auto',
    tabIndex: -1,
    // buttons: ['fontsize', 'bold', 'italic', 'underline', 'brush', 'hr', 'image', 'link', 'align', 'paragraph', 'ul', 'ol', 'source'],
    buttons: ['fontsize', 'bold', 'italic', 'underline', 'brush', 'hr', 'align', 'ul', 'ol'],
    link: {
        modeClassName: false,
        noFollowCheckbox: false,
        openInNewTabCheckbox: false,
        processPastedLink: false,
        processVideoLink: false,
        selectMultipleClassName: false,
        selectOptionsClassName: false,
    },
    imageDefaultWidth: 24,
    image: {
        dialogWidth: true,
        editAlign: false,
        editAlt: false,
        editBorderRadius: true,
        editClass: false,
        editId: false,
        editLink: true,
        editMargins: false,
        editSize: true,
        editSrc: true,
        editStyle: false,
        editTitle: false,
        openOnDblClick: true,
        selectImageAfterClose: true,
        showPreview: true,
        useImageEditor: true,
    },
    placeholder: "Digite o texto aqui...",
    toolbarAdaptive: false
}